<div class="col-12 block">
    <h1>產業分類</h1>
    <div class="content sort">

        <ng-container *ngFor="let item of Data">

            <div class="card {{(item.hasEvent) ? '' : 'nodata'}}"  (click)="SetSearch(item)">
                <div class="item">
                    <div class="imgbox">
                        <img src="{{item.icon}}"/>
                    </div>
                    <label>{{item.name}}</label>
                    <p>{{item.desc}}</p>
                </div>
            </div>

        </ng-container>
        
        <!-- <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s1.png"/>
                <label>五金手工／扣件</label>
                <p>Gym Equipment／gear cutting machine／gear cutting tools…</p>
            </div>
        </div>

        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s2.png"/>
                <label>機械／工具機</label>
                <p>Machinery／Metalworking／模具自動化機械設備／智慧機械／機器...</p>
            </div>
        </div>
        
        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s3.png"/>
                <label>食品／農產品</label>
                <p>高粱酒／牛軋糖／果凍／餅乾／各類果乾</p>
            </div>
        </div>
        
        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s4.png"/>
                <label>醫療器材／生技</label>
                <p>採購品項／採購品項／採購品項／採購品項／採購品項</p>
            </div>
        </div>
        
        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s5.png"/>
                <label>紡織／服飾配件</label>
                <p>Sport Function Fabric／Bicycle accessories／frames／saddles…</p>
            </div>
        </div>
        
        <div class="card nodata">
            <div class="item">
                <img src="../assets/images/sort/s6.png"/>
                <label>生活用品</label>
                <p></p>
            </div>
        </div>

        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s7.png"/>
                <label>美容用品</label>
                <p>採購品項／採購品項／採購品項／採購品項／採購品項</p>
            </div>
        </div>

        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s8.png"/>
                <label>資通訊電子零組件／ 綠能產品</label>
                <p>採購品項／採購品項／採購品項／採購品項／採購品項</p>
            </div>
        </div>

        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s9.png"/>
                <label>化學／橡塑膠／儀器／光學／紙／包裝</label>
                <p>採購品項／採購品項／採購品項／採購品項／採購品項</p>
            </div>
        </div>

        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s10.png"/>
                <label>紡織／服飾配件</label>
                <p>採購品項／採購品項／採購品項／採購品項／採購品項</p>
            </div>
        </div>

        <div class="card">
            <div class="item">
                <img src="../assets/images/sort/s11.png"/>
                <label>自行車／運動用品</label>
                <p>採購品項／採購品項／採購品項／採購品項／採購品項</p>
            </div>
        </div>

        <div class="card nodata">
            <div class="item">
                <img src="../assets/images/sort/s12.png"/>
                <label>服務業</label>
                <p></p>
            </div>
        </div> -->
    </div>
</div>